/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */


import { pageApi } from '@/main/api/page.api';
import { EHttpMethod } from '@modules/app/appConstants';

import { ACCOUNT_INFO, API_EDM_OPERATORS, CANCEL, EDM_CONNECTIONS, EDM_CONNECTIONS_ADD, UPDATE } from '../app/Api';
import { edmDeliveryTags, pageAccountInfoTags } from '../app/apiTags';
import type { IEdmConnectionAddRequest, IEdmConnectionCancelRequest, IEdmOperatorsResponse, IEdmResponsibleUpdateRequest, IOperatorsOptions } from './types';
import { mapEdmOperatorsToSelectOptions } from './util/transformEdmDelivery';

export const edmDeliveryApi = pageApi.injectEndpoints({
    endpoints: (builder) => ({
        getEdmOperators: builder.query<IOperatorsOptions, void>({
            query: () => ({
                url: API_EDM_OPERATORS,
            }),
            transformResponse: (response: IEdmOperatorsResponse) => {
                return mapEdmOperatorsToSelectOptions(response.operators);
            },
            providesTags: [edmDeliveryTags.EDM_OPERATORS],
        }),
        addEdmConnection: builder.mutation<void, IEdmConnectionAddRequest>({
            query: ({ bisAccountId, edmConnectionAddData }) => ({
                url: `${ACCOUNT_INFO}/${bisAccountId}/${EDM_CONNECTIONS_ADD}`,
                method: EHttpMethod.POST,
                body: edmConnectionAddData,
            }),
            invalidatesTags: [pageAccountInfoTags.ACCOUNT_INFO_DELIVERY_META],
        }),
        cancelEdmConnection: builder.mutation<void, IEdmConnectionCancelRequest>({
            query: ({ bisAccountId, edmConnectionId }) => ({
                url: `${ACCOUNT_INFO}/${bisAccountId}/${EDM_CONNECTIONS}/${edmConnectionId}/${CANCEL}`,
                method: EHttpMethod.PUT,
            }),
            invalidatesTags: [pageAccountInfoTags.ACCOUNT_INFO_DELIVERY_META],
        }),
        updateEdmResponsibleContact: builder.mutation<void, IEdmResponsibleUpdateRequest>({
            query: ({ bisAccountId, edmConnectionId, data }) => ({
                url: `${ACCOUNT_INFO}/${bisAccountId}/${EDM_CONNECTIONS}/${edmConnectionId}/${UPDATE}`,
                method: EHttpMethod.POST,
                body: data,
            }),
            invalidatesTags: [pageAccountInfoTags.ACCOUNT_INFO_DELIVERY_META],
        }),
    }),
});

export const {
    useGetEdmOperatorsQuery,
    useAddEdmConnectionMutation,
    useCancelEdmConnectionMutation,
    useUpdateEdmResponsibleContactMutation,
} = edmDeliveryApi;
